export function getCookieValue(name) {
  if (typeof document === 'undefined') return '';
  const cookie = document.cookie || '';
  const match = cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  if (!match) return '';
  try {
    return decodeURIComponent(match[1] || '');
  } catch (_) {
    return match[1] || '';
  }
}

// Google Translate widget writes a cookie like: googtrans=/en/kn
export function getGoogleTranslateTargetLangFromCookie() {
  const raw = getCookieValue('googtrans');
  if (!raw) return '';
  // Expected shapes:
  // - /en/kn
  // - /auto/ta
  const parts = String(raw).split('/');
  const lang = parts?.[2] || '';
  return (lang || '').toString().trim();
}

export function normalizeLangCode(rawCode) {
  if (!rawCode) return '';
  return String(rawCode).trim().replace(/_/g, '-');
}


